const JobResources = {
  DEFAULT_CPUS: 0.01,
  DEFAULT_DISK: 0,
  DEFAULT_MEM: 128
};

module.exports = JobResources;



// WEBPACK FOOTER //
// ./src/js/constants/JobResources.js